import React, { Component } from 'react';
import './ReadMore.css';

export default class ReadMore extends Component {
    constructor(props) {
        super(props);
        this.state = {expanded: false};
    }

    toggle() {
        this.setState({expanded: !this.state.expanded});
    }

    render() {
        let button = [];
        if (!this.state.expanded) {
            button = <div onClick={this.toggle.bind(this)} className="readmorebutton">Read more...</div>;
        }

        return <React.Fragment>{button}<div class={"text readmore" + (this.state.expanded ? " expanded" : "")}>
            {this.props.content.map(t => <p>{t}</p>)}
        </div></React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/ReadMore/ReadMore.jsx